import { createContext, useContext, type ReactNode } from "react";

const TableNoDataEmptyContext = createContext(false);

export function TableNoDataEmptyProvider({ value, children }: { value: boolean; children: ReactNode }) {
  return <TableNoDataEmptyContext.Provider value={value}>{children}</TableNoDataEmptyContext.Provider>;
}

export function useTableNoDataEmpty() {
  return useContext(TableNoDataEmptyContext);
}
